import { useTranslation } from "react-i18next";
import React from "react";
import { LocaleLink } from "../../i18n/LocaleLink";

export const CtaAreaTwo = () => {
  const { t } = useTranslation();
  return (
    <section className="cta-area-two pt-120">
      <div className="container">
        <div className="cta-inner-wrap-two">
          <div className="row align-items-center">
            <div className="col-lg-9">
              <div className="cta-content">
                <div className="cta-info-wrap">
                  <div className="icon">
                    <i className="flaticon-phone-call"></i>
                  </div>
                  <div className="content">
                    <span>{t("cta.callUs")}</span>
                    <a href="tel:0573044089089">+57 304 408 9089</a>
                  </div>
                </div>
                <h2 className="title">{t("cta.title")}</h2>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cta-btn text-end">
                <LocaleLink
                  to="https://calendar.app.google/bvJMxpaXmpgWf7VS6"
                  className="btn btn-three"
                >
                  {t("cta.schedule")}
                </LocaleLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
